// extracted by mini-css-extract-plugin
export default {"Title":"webpack-pages-DataExtraction-QualityAssessmentTemplate-DefaultTemplate-components-SectionTitle-module__Title"};